import { Box, MenuItem, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { SyncLoader } from "react-spinners";
import { toast, ToastContainer, Zoom } from "react-toastify";
import { handleEditClose } from "../../../redux/Reducer/ModalSlice";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../Volunteer/Volunteer.style";
import "react-toastify/dist/ReactToastify.css";

const EditTrials = ({ userData }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();
  const trialData = useSelector((state) => state.Modal.val);

  // console.log("i am trial data", trialData);

  //! get trials list api
  const { refetch, data: allTrialsDetails = [] } = useQuery({
    queryKey: ["allTrialsDetails"],
    queryFn: async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/trial`);
      const data = await res.json();
      return data.data;
    },
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit = (data, e) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);

    const formData = new FormData();
    formData.append("trial_name", data.trial_name);
    formData.append("description", data.description);
    formData.append("active_flag", data.active_flag);
    formData.append("updated_by", userData?.id);

    fetch(`${process.env.REACT_APP_API_URL}/api/trial/${trialData?.trial_id}`, {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.meta.status === true) {
          toast.success("Trial Update Successful", {
            position: toast.POSITION.TOP_CENTER,
          });
          refetch().then(() => {
            dispatch(handleEditClose());
          });
        } else if (data.duplicate === true) {
          toast.error("This study is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {/* trial name */}
      <Box p="20px">
        <TextField
          size="small"
          defaultValue={trialData?.trial_name}
          fullWidth
          label="Trial Name*"
          variant="outlined"
          {...register("trial_name", { required: true })}
        />
        {errors?.study_code?.type === "required" && (
          <ErrorMessage>Trial name is required*</ErrorMessage>
        )}
      </Box>

      {/* trial description */}
      <Box p=" 0 20px 20px 20px">
        <TextField
          size="small"
          fullWidth
          defaultValue={trialData?.description}
          label="Trial Description*"
          variant="outlined"
          {...register("description", { required: true })}
        />
        {errors?.protocol_title?.type === "required" && (
          <ErrorMessage>Trial description is required*</ErrorMessage>
        )}
      </Box>

      {/* active inactive */}
      <Box p=" 0 20px 20px 20px">
        <TextField
          select
          defaultValue={trialData?.active_flag}
          size="small"
          fullWidth
          label="Active Status"
          variant="outlined"
          {...register("active_flag", {
            // required: true
          })}
        >
          <MenuItem value="1">Active</MenuItem>
          <MenuItem value="0">Inactive</MenuItem>
        </TextField>
        {errors?.astatus_fg?.type === "required" && (
          <ErrorMessage>Active status is required*</ErrorMessage>
        )}
      </Box>

      {/* add button */}
      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {isLoading ? (
          <ThemButton style={{}} type="submit">
            <SyncLoader color="#FFFFFF" size={8} />
          </ThemButton>
        ) : (
          <ThemButton style={{}} type="submit">
            Update Trial
          </ThemButton>
        )}

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />
      </Box>
    </form>
  );
};

export default EditTrials;
